<div class="section-card" [formGroup]="group">
    <div class="section-header">
        <span class="s-icon">👤</span>
        <h3>Student Information</h3>
    </div>
    <div class="section-body">
        <div class="row g-3">
            <div class="col-md-4">
                <div class="field">
                    <label class="field-label">First Name <span class="req">*</span></label>
                    <input [class.is-invalid]="group.get('first_name')?.invalid && group.get('first_name')?.touched"
                           class="f-input"
                           formControlName="first_name"
                           placeholder="Enter first name">
                </div>
            </div>
            <div class="col-md-4">
                <div class="field">
                    <label class="field-label">Middle Name <span class="opt">(Optional)</span></label>
                    <input class="f-input" formControlName="middle_name" placeholder="Enter middle name">
                </div>
            </div>
            <div class="col-md-4">
                <div class="field">
                    <label class="field-label">Last Name <span class="req">*</span></label>
                    <input [class.is-invalid]="group.get('last_name')?.invalid && group.get('last_name')?.touched"
                           class="f-input"
                           formControlName="last_name"
                           placeholder="Enter last name">
                </div>
            </div>
            <div class="col-md-3">
                <div class="field">
                    <label class="field-label">Gender <span class="req">*</span></label>
                    <select [class.is-invalid]="group.get('gender_id')?.invalid && group.get('gender_id')?.touched"
                            class="f-select"
                            formControlName="gender_id">
                        <option value="">Select Gender</option>
                        @for (item of genders; track item.value) {
                            <option [value]="item.value">{{ item.label }}</option>
                        }
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <div class="field">
                    <label class="field-label">Date of Birth <span class="req">*</span></label>
                    <input [class.is-invalid]="group.get('date_of_birth')?.invalid && group.get('date_of_birth')?.touched"
                           class="f-input"
                           formControlName="date_of_birth"
                           type="date">
                </div>
            </div>
            <div class="col-md-3">
                <div class="field">
                    <label class="field-label">Place of Birth <span class="req">*</span></label>
                    <input [class.is-invalid]="group.get('place_of_birth')?.invalid && group.get('place_of_birth')?.touched"
                           class="f-input"
                           formControlName="place_of_birth"
                           placeholder="City / Town">
                </div>
            </div>
            <div class="col-md-3">
                <div class="field">
                    <label class="field-label">Religion <span class="req">*</span></label>
                    <select [class.is-invalid]="group.get('religion_id')?.invalid && group.get('religion_id')?.touched"
                            class="f-select"
                            formControlName="religion_id">
                        <option value="">Select Religion</option>
                        @for (item of religions; track item.value) {
                            <option [value]="item.value">{{ item.label }}</option>
                        }
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <div class="field">
                    <label class="field-label">Mother Tongue <span class="req">*</span></label>
                    <select [class.is-invalid]="group.get('mother_tongue_id')?.invalid && group.get('mother_tongue_id')?.touched"
                            class="f-select"
                            formControlName="mother_tongue_id">
                        <option value="">Select Mother Tongue</option>
                        @for (item of motherTongue; track item.value) {
                            <option [value]="item.value">{{ item.label }}</option>
                        }
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <div class="field">
                    <label class="field-label">Blood Group <span class="req">*</span></label>
                    <select [class.is-invalid]="group.get('blood_group_id')?.invalid && group.get('blood_group_id')?.touched"
                            class="f-select"
                            formControlName="blood_group_id">
                        <option value="">Select Blood Group</option>
                        @for (item of bloodGroupsType; track item.value) {
                            <option [value]="item.value">{{ item.label }}</option>
                        }
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <div class="field">
                    <label class="field-label">Cast / Category <span class="req">*</span></label>
                    <select [class.is-invalid]="group.get('category_id')?.invalid && group.get('category_id')?.touched"
                            class="f-select"
                            formControlName="category_id">
                        <option value="">Select Category</option>
                        @for (item of castCategoryType; track item.value) {
                            <option [value]="item.value">{{ item.label }}</option>
                        }
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <div class="field">
                    <label class="field-label">Aadhaar <span class="req">*</span></label>
                    <input (input)="numbersOnly.emit($event)"
                           [class.is-invalid]="group.get('aadhaar')?.invalid && group.get('aadhaar')?.touched"
                           class="f-input"
                           formControlName="aadhaar"
                           inputmode="numeric"
                           maxlength="12"
                           placeholder="12-digit Aadhaar"
                           type="text">
                </div>
            </div>
        </div>
    </div>
</div>
